import './Card.css';

function Card(props) {
  const backSide = (
    <div className="stacked-linear-background"></div>
  );

  return (
    <div className="card" onClick={() => props.onClick(props.cardIndex)}>
      {props.open ? props.children : backSide}
    </div>
  );
}

export default Card;